import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service, {
    getDataFlowV2FieldErrors,
} from "src/modules/data-protection/apis/DataFlowV2Service";
import { invalidateSoftwareDataFlowsV2 } from "./useSoftwareDataFlowsV2";

const useCreateDataFlow = ({ softwareId, t, onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataFlowV2Service.getInstance();

            return await service.createDataFlow(payload);
        },
        onSuccess: () => {
            toast(t("Data flow created successfully."), {
                type: "success",
            });

            invalidateSoftwareDataFlowsV2(queryClient);

            if (typeof onSuccess === "function") {
                onSuccess();
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            const fieldErrors = getDataFlowV2FieldErrors(error);

            if (typeof onError === "function") {
                onError(fieldErrors);
            }

            if (!Object.keys(fieldErrors).length) {
                toast(t("Failed to create data flow."), {
                    type: "error",
                });
            }
        },
    });

    return {
        createFlow: mutation.mutate,
        isSaving: mutation.isLoading,
    };
};

export default useCreateDataFlow;
